import { ImageListItem, styled } from "@mui/material";
import { KTSVG } from "../../../../_metronic/helpers";
import { Folder } from "../media/mediaModels";
import { NewTemplateSetting } from "../template/templateModels";
import { Widget } from "../widget/widgetModel";

export interface InitialState {
    
    hideDashboard: boolean,
    hidePanelRight: boolean,
    editorModeOn: boolean,
    
    currentFolder: Folder,
    selectedMenu: string,

    currWidget: Widget,
    
    currEditorWidth : number,
    currEditorHeight: number,
    newSelectedContentIds : string[],
    zoomPercentage: number,    

    multiSelectMode: boolean,
    selectedMediaSrcIds: string[],

    textEditorCnt : string,

    editorStatusParams: EditorStatusParams,

    templateToolsSettings: NewTemplateSetting,
}

export interface EditorStatusParams {
    // editorModeOn: boolean,
    // hideDashboard: boolean,
    // hidePanelRight: boolean,

    savingStatus: number,   //-1: emptyContent;  0: unsaved/changed;   1: saving;  2: saved;

}

// Data Pre-assignment
// ----------------------------------------------
//16:9 at 1/120 propotion
// export const deviceWidth  = 1920
// export const deviceHeight = 1080
// //16:9 at 1/80 propotion
// export const defaultEditorWidth  = 1280
// export const defaultEditorHeight = 720
// //16:9 at 1/60 propotion

export const DEBUG_MODE : boolean | undefined  = (process.env.REACT_APP_DEBUG_MODE
    ?   (process.env.REACT_APP_DEBUG_MODE === "true" || process.env.REACT_APP_DEBUG_MODE !== "0"
            ? true 
            : false
        )
    :   false
    )

/* Open fullscreen */
export const openFullscreen = () =>{
    var elem = document.documentElement
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    // } else if (elem.webkitRequestFullscreen) { /* Safari */
    //   elem.webkitRequestFullscreen();
    // } else if (elem.msRequestFullscreen) { /* IE11 */
    //   elem.msRequestFullscreen();
    }
    }

/* Close fullscreen */
export const closeFullscreen = () => {
    // var elem = document.documentElement
    // if (document.exitFullscreen) {    
    //     document.exitFullscreen();
    // // } else if (document.webkitExitFullscreen) { /* Safari */
    // //   document.webkitExitFullscreen();
    // // } else if (document.msExitFullscreen) { /* IE11 */
    // //   document.msExitFullscreen();
    // }

    // if (document.fullscreenElement !== null) {
    //     document.exitFullscreen();
    // }
    if (document.fullscreenElement) {
        setTimeout(() => document.exitFullscreen(), 1000);
    }
}


export const ImageListItemWithStyle = styled(ImageListItem)(({ theme }) => ({
    border: `solid 1px #E4E6EF`,
    "&:hover MuiImageListItemBar-root span.text-muted":{
        color:"#fff"
    },
    
    "&:hover": {
        cursor: "pointer",
        // opacity: 0.8,
        border: `solid 1px #D58DCF`,
        // boxShadow: `inset 0 0 0 1px #FBE5F9`,
        backgroundColor:`#FBE5F9`,
        color:`#fff`,
        borderRadius:"0 0 2px 2px",
        //boxShadow: `5px 10px ${theme.palette.primary.main}`,
    },
}));

export const ImageListItem2WithStyle = styled(ImageListItem)(({ theme }) => ({
    border: `solid 1px #E4E6EF`,
    "&:hover MuiImageListItemBar-root span.text-muted":{
        color:"#fff"
    },   
    
    "&:hover": {
        cursor: "pointer",
        // border: `solid 0px #009ef7`,
        // backgroundColor:`#FBE5F9`,
        backgroundColor:`#009ef7`,
        // color:`#fefefe`,
        borderRadius:"7px",
        //boxShadow: `5px 10px ${theme.palette.primary.main}`,
    },
    
}));

// Get the icon correspond to each section
// export const sectColorCodes = {
//     "image": "info",
//     "video": "info",
//     "web"  : "success",    
//     "text" : "warning",    
// }


export const getSectColorCodes = (sectType="image", clsName="") => {
    return  (
            ["image", "video"].includes(sectType) ? "gray-700"
            :   ["web"].includes(sectType) ? "primary" 
                :   ["text"].includes(sectType) ? "info"
                    :   ["widget"].includes(sectType) ? "success" : ""
    )
}

export const getSectColorHexCodes = (sectType="image") => {
    return  (
            ["image", "video"].includes(sectType) ? "#5E627888"
            :   ["web"].includes(sectType) ? "#9C258F88" 
                :   ["text"].includes(sectType) ? "#009ef788"
                    :   ["widget"].includes(sectType) ? "#4FA34B88" : ""
    )
}

// Get the icon correspond to each section
export const getSectionIcon = (sectType="image", clsName="", iconClsName="w-20px") => {
    return (
            <span className={iconClsName}>
                {sectType === "image"    && <KTSVG path='/media/icons/duotune/general/gen006.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
                {sectType === "video"    && <i className={`bi bi-camera-video-fill me-2 ${clsName}`}></i>}
                {sectType === "text"     && <KTSVG path='/media/icons/duotune/art/art001.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
                {sectType === "web"      && <i className={`bi bi-globe me-2 ${clsName}`}></i>}
                {sectType === "widget"   && <KTSVG path='/media/icons/duotune/general/gen025.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
                {sectType === "campaign" && <KTSVG path='/media/icons/duotune/abstract/abs026.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
                {sectType === "other"    && <KTSVG path='/media/icons/duotune/general/gen046.svg'  className={`svg-icon-4 me-2 ${clsName}`}/>}

                {sectType === "date"        && <KTSVG path='/media/icons/duotune/general/gen014.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
                {sectType === "clock"       && <KTSVG path='/media/icons/duotune/general/gen013.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
                {sectType === "time"        && <span className={`badge fs-4 ${clsName} ps-0 me-2`}>AM</span>}
                {sectType === "weather"     && <KTSVG path='/media/icons/duotune/abstract/abs007.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}                
                {sectType === "weather forecast"     && <KTSVG path='/media/icons/duotune/abstract/abs007.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}                
                {sectType === "qr code"     && <i className={`bi bi-qr-code me-2 ${clsName}`}></i>}
                {sectType === "count down"  && <KTSVG path='/media/icons/duotune/abstract/abs019.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
                {sectType === "youtube"     && <KTSVG path='/media/icons/duotune/social/soc007.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
                {sectType === "google sheet" && <KTSVG path='/media/icons/duotune/files/fil002.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
                
                {sectType === "dashboard"       && <KTSVG path='/media/icons/duotune/coding/cod003.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
                {sectType === "zoom"            && <KTSVG path='/media/icons/duotune/coding/cod003.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
                {sectType === "api integration" && <KTSVG path='/media/icons/duotune/coding/cod003.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
                {sectType === "reward gateway"  && <KTSVG path='/media/icons/duotune/coding/cod003.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
                {sectType === "external data source" && <KTSVG path='/media/icons/duotune/coding/cod003.svg' className={`svg-icon-4 me-2 ${clsName}`}/>}
            </span>
    )           
}

// Get the icon correspond to each section
export const getSectionIconUnicode = (sectType="image") => {
    switch(sectType){
        case 'image' : return '\uf03d'; break;
        case 'video' : return '\uf03d'; break;
        case 'text'  : return '\uf034'; break;
        case 'web'   : return '\uf0ac'; break;
        case 'widget': return '\uf009'; break;                   
    }    
}

export const getSectionIconWidth = (sectType="image") => {
    switch(sectType){
        case 'image' : return 28; break;
        case 'video' : return 28; break;
        case 'text'  : return 28; break;
        default  : return 27; break;        
    }    
}


export const extractYouTubeVideoId = (url = "") => {
    const videoID = url.match(/(?:https?:\/\/)?(?:www\.)?youtu(?:be)?\.(?:com|be)\/(?:watch\?v=|embed\/|v\/|)([^#&?]+)/);
    return videoID ? videoID [1] : null;
}
// --------------------------------------------
// Calculate the propotion of Editor (16:9 screensize)
// --------------------------------------------
export const DEFAULT_LOAD_ATTEMPT = 5   //nb. of attempts to download the img/video after uploading to S3

export const defaultEditorLandscapeWidth  = 960
export const defaultEditorLandscapeHeight = 540

export const defaultEditorPortraitWidth  = 315
export const defaultEditorPortraitHeight = 560

export const defaultVideoVolume = 25
export const minimumVideoVolume = 0
export const maximumVideoVolume = 100

export const RECYCLE_BIN_DURATION = 7   //files will be auto-deleted after 7 days in the bin


// To map from a real value to our editor size
// ----------------------------------------------
export const getCorrespondWidth = (w:number, h:number, realEditorW: number, realEditorH: number, zoom:number = 1) => {
    if (realEditorW >= realEditorH){
        return w==0 ? 0 : Math.round((w*(defaultEditorLandscapeWidth / realEditorW))* zoom)
    }else{
        return w==0 ? 0 : Math.round((w*(defaultEditorPortraitWidth  / realEditorW))* zoom)
    }
}
  
export const getCorrespondHeight = (w:number, h:number, realEditorW: number, realEditorH: number, zoom:number = 1) => {    
    if (realEditorW >= realEditorH){
        return h==0 ? 0 : Math.round((h*(defaultEditorLandscapeHeight / realEditorH))* zoom)
    }else{
        return h==0 ? 0 : Math.round((h*(defaultEditorPortraitHeight  / realEditorH))* zoom)
    }
}

// To map from an editor scaled size to a real value 
// ----------------------------------------------
export const getRealWidth = (w:number, h:number, realEditorW: number, realEditorH: number, zoom:number = 1) => {
    if (realEditorW >= realEditorH){
        return w==0 ? 0 : Math.round((w / zoom)*(realEditorW / defaultEditorLandscapeWidth))
    }else{
        return w==0 ? 0 : Math.round((w / zoom)*(realEditorW / defaultEditorPortraitWidth))
    }
}
  
export const getRealHeight = (w:number, h:number, realEditorW: number, realEditorH: number, zoom:number = 1) => {    
    if (realEditorW >= realEditorH){
        return h==0 ? 0 : Math.round((h / zoom)*(realEditorH / defaultEditorLandscapeHeight))
    }else{
        return h==0 ? 0 : Math.round((h / zoom)*(realEditorH / defaultEditorPortraitHeight))
    }
}